// Static site data: contact info, images, room meta (language-independent)

export const CONTACT = {
  whatsapp: "50587885920",
  whatsappDisplay: "+505 8788 5920",
  email: "casa.romano.sanjuan@gmail.com",
  mapsUrl:
    "https://www.google.com/maps/place/Casa+Romano+Hostel+San+Juan+del+Sur/data=!4m2!3m1!1s0x8f75b443d56e235d:0x6831b3c894d92e97",
  reviewsUrl:
    "https://www.google.com/maps/place/Casa+Romano+Hostel+San+Juan+del+Sur/data=!4m2!3m1!1s0x8f75b443d56e235d:0x6831b3c894d92e97",
  writeReviewUrl: "https://www.google.com/maps/place/Casa+Romano+Hostel+San+Juan+del+Sur/data=!4m2!3m1!1s0x8f75b443d56e235d:0x6831b3c894d92e97",
  facebook: "https://www.facebook.com/casa.romano.sanjuan/",
  instagram: "https://www.instagram.com/casa.romano/",
  rating: "4.4",
  reviewCount: "98",
};

export const IMAGES = {
  logo: "/logo.png",
  storefront:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_2b66a023-37d3-4f36-a818-23a80cd5d307/artifacts/3829ru67_image.png",
  heroBeach:
    "https://images.unsplash.com/photo-1505703667075-5578a18d3385?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  bay:
    "https://images.unsplash.com/photo-1734490139082-8ef790bd0b21?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  sunset:
    "https://images.unsplash.com/photo-1713186266823-9491048a94d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  surf:
    "https://images.unsplash.com/photo-1531352568100-8194a5f7a16e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  kitchen:
    "https://images.unsplash.com/photo-1618506425498-93e6a45e3af0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  sjdsSign: "/sjds-sign.jpg",
  cristoStatue: "/cristo-de-la-misericordia-san-juan-del-sur.jpg",
  sjdsSunset: "/san-juan-del-sur-sunset.jpg",
  sjdsSignDay: "/san-juan-del-sur-sign-day.webp",
  casaSunset: "/gallery/sunset-boats.webp",
  heroVideo:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_casa-romano-booking/artifacts/52vu1f0a__users_f8e3a7bf-22c2-45c4-b32e-ca04daf92e70_generated_9e726bfc-f658-4597-9766-365fac593de4_generated_video.MP4",
};

// Room meta: images + guest count. Text comes from translations (rooms.list index).
export const ROOMS_META = [
  {
    id: "double-fan",
    order: 1,
    count: 2,
    available: 2,
    guests: 2,
    price: 30,
    images: ["/rooms/fan-1.webp", "/rooms/fan-2.webp", "/rooms/fan-3.webp", "/rooms/fan-4.webp", "/rooms/fan-5.webp", "/rooms/fan-6.webp", "/rooms/fan-7.webp", "/rooms/fan-8.webp", "/rooms/fan-9.webp"],
    span: "lg:col-span-6",
  },
  {
    id: "double-ac",
    order: 2,
    count: 2,
    available: 2,
    guests: 2,
    price: 40,
    images: ["/rooms/ac-1.webp", "/rooms/ac-2.webp", "/rooms/ac-3.webp", "/rooms/ac-4.webp", "/rooms/ac-5.webp", "/rooms/ac-6.webp", "/rooms/ac-7.webp", "/rooms/ac-8.webp", "/rooms/ac-9.webp"],
    span: "lg:col-span-6",
  },
  {
    id: "double-balcony",
    hidden: true,
    order: 0,
    count: 2,
    guests: 2,
    price: 40,
    images: ["/rooms/balcony-1.jpg"],
    span: "lg:col-span-6",
  },
  {
    id: "triple",
    order: 4,
    count: 1,
    guests: 3,
    price: 50,
    images: ["/rooms/triple-1.jpg", "/rooms/triple-2.jpg", "/rooms/triple-3.jpg", "/rooms/triple-4.webp", "/rooms/triple-5.webp", "/rooms/triple-6.webp"],
    span: "lg:col-span-6",
  },
  {
    id: "quadruple",
    order: 5,
    count: 1,
    guests: 4,
    price: 65,
    images: ["/rooms/quad-1.jpg", "/rooms/quad-2.jpg", "/rooms/quad-bath.jpg", "/rooms/quad-4.webp"],
    span: "lg:col-span-12",
  },
  {
    id: "double-ac-2",
    order: 3,
    count: 2,
    available: 2,
    guests: 2,
    price: 40,
    images: ["/rooms/fan2-1.webp", "/rooms/fan2-2.webp", "/rooms/fan2-3.webp", "/rooms/fan2-4b.webp", "/rooms/fan2-5b.webp", "/rooms/fan2-6.webp", "/rooms/fan2-9.webp", "/rooms/fan2-10.webp", "/rooms/fan2-7.webp", "/rooms/fan2-8.webp"],
    span: "lg:col-span-6",
  },
];

// Photo gallery — real Casa Romano photos + local flavour. OWNER: add/replace URLs here.
export const GALLERY = [
  { src: IMAGES.storefront, tall: true },
  { src: "/rooms/gallery-1.webp", tall: true },
  { src: "/gallery/twilight-moon.webp", tall: true },
  { src: "/rooms/double-ac.jpg", tall: true },
  { src: "/rooms/gallery-6.webp", tall: true },
  { src: IMAGES.heroBeach },
  { src: "/gallery/sunset-boats.webp", tall: true },
  { src: "/rooms/gallery-2.webp", tall: true },
  { src: "/rooms/double-fan.jpg" },
  { src: "/rooms/gallery-7.webp" },
  { src: "/gallery/rainbow-bay.webp", tall: true },
  { src: "/rooms/bathroom.jpg", tall: true },
  { src: "/rooms/gallery-3.webp", tall: true },
  { src: IMAGES.bay },
  { src: "/gallery/cliff-view.webp", tall: true },
  { src: "/rooms/triple.jpg", tall: true },
  { src: "/rooms/gallery-8.webp", tall: true },
  { src: "/rooms/gallery-4.webp", tall: true },
  { src: IMAGES.surf },
  { src: "/gallery/night-harbor.webp", tall: true },
  { src: "/rooms/quadruple.jpg", tall: true },
  { src: "/rooms/gallery-9.webp", tall: true },
  { src: "/rooms/gallery-5.webp", tall: true },
  { src: "/rooms/gallery-boat.webp", tall: true },
];

export const LANGS = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇳🇮" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
];
